module.exports = __webpack_public_path__ + "c39c51ac.svg";